export enum FailedLogHeaderTableColmunNames {
  LOG_HEADER_ID = 'logHeaderId',
  PRO_NBR = 'proNbr',
  ERROR_MESSAGE = 'error',
  RETRY = 'retry',
}
